module.exports = __webpack_public_path__ + "static/media/EC.55bbbbc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/EC.svg
// module id = 243
// module chunks = 0